<div class="grid" *ngIf="cargando">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br />
    <span>{{ "LBL_CONSULTANDO" | translate }}</span>
  </div>
</div>
<div *ngIf="!cargando">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12 text-center titulo">
      <label>{{ "SARLAFT.LBL_TITULOSIMULADOR" | translate | uppercase }}</label>
    </div>
  </div>
  <table class="align-tabla">
    <thead>
      <tr class="subTitulo">
        <th>{{"SARLAFT.LBL_VARAIBLES" | translate | uppercase}}</th>
        <th>{{"SARLAFT.LBL_PESOSINSIGNO" | translate | uppercase}}</th>
        <th>{{"SARLAFT.LBL_PUNTAJE" | translate | uppercase}}</th>
        <th>{{"SARLAFT.LBL_SCOREPORVARIABLE" | translate | uppercase}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="mostrarDeterminantes">
        <td colspan="4">
          <div class="aling-subtitulo">
            {{"SARLAFT.LBL_DETERMINANTES" | translate | uppercase}}
          </div>
        </td>
      </tr>
      <ng-container *ngFor="let item of variablesSimulador">
        <ng-container *ngIf="item.indicadorDeterminante">
          <tr>
            <td>
              <label>{{ item.variableSarlaft }}</label>
              <p-dropdown disableTab  filter="true"  placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                id="{{'variable_' + item.codigoVariableSarlaft }}"
                name="{{ 'variable_' + item.codigoVariableSarlaft }}"
                [options]="item.listGenerica"
                [(ngModel)]="listValores['variable_'+ item.codigoVariableSarlaft]"
                (onChange)="onDropdownChange(item)"
                          emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          optionValue="value"
                          optionLabel="label"
              ></p-dropdown>
            </td>
            <td>
              <input class="align-input" type="text" pInputText autocomplete="off" appTexto numero-entero-reactive disabled maxlength="5"
                [sinComa]="true" [sinEspacio]="true" [sinCaracteres]="true" [sinPunto]="true" [sinLetras]="true"
                id="{{ 'peso_' + item.codigoVariableSarlaft }}"
                name="{{ 'peso_' + item.codigoVariableSarlaft }}"
                [(ngModel)]="listValores['peso_'+ item.codigoVariableSarlaft]"
              >
            </td>
            <td>
              <input class="align-input" type="text" pInputText autocomplete="off" appTexto numero-entero-reactive disabled maxlength="5"
                [sinComa]="true" [sinEspacio]="true" [sinCaracteres]="true" [sinPunto]="true" [sinLetras]="true"
                id="{{ 'puntaje_' + item.codigoVariableSarlaft }}"
                name="{{ 'puntaje_' + item.codigoVariableSarlaft }}"
                [(ngModel)]="listValores['puntaje_'+ item.codigoVariableSarlaft]"
              >
            </td>
            <td>
              <input class="align-input" type="text" pInputText autocomplete="off" appTexto numero-entero-reactive disabled maxlength="5"
                [sinComa]="true" [sinEspacio]="true" [sinCaracteres]="true" [sinPunto]="true" [sinLetras]="true"
                id="{{ 'resultado_' + item.codigoVariableSarlaft }}"
                name="{{ 'resultado_' + item.codigoVariableSarlaft }}"
                [(ngModel)]="listValores['resultado_'+ item.codigoVariableSarlaft]"
              >
            </td>
          </tr>
        </ng-container>
      </ng-container>
      <tr *ngIf="mostrarCuantitativas">
        <td colspan="4">
          <div class="aling-subtitulo">
            {{"SARLAFT.LBL_CUANTITATIVAS" | translate | uppercase}}
          </div>
        </td>
      </tr>
      <ng-container *ngFor="let item of variablesSimulador">
        <ng-container *ngIf="!item.indicadorDeterminante">
          <tr>
            <td>
              <label>{{ item.variableSarlaft }}</label>
              <p-dropdown disableTab  filter="true"  placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                id="{{ 'variable_' + item.codigoVariableSarlaft }}"
                name="{{ 'variable_' + item.codigoVariableSarlaft }}"
                [options]="item.listGenerica"
                [(ngModel)]="listValores['variable_'+ item.codigoVariableSarlaft]"
                (onChange)="onDropdownChange(item)"
                          emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          optionValue="value"
                          optionLabel="label"
              ></p-dropdown>
            </td>
            <td>
              <input class="align-input" type="text" pInputText autocomplete="off" appTexto numero-entero-reactive disabled maxlength="5"
              [sinComa]="true" [sinEspacio]="true" [sinCaracteres]="true" [sinPunto]="true" [sinLetras]="true"
              id="{{ 'peso_' + item.codigoVariableSarlaft }}"
              name="{{ 'peso_' + item.codigoVariableSarlaft }}"
              [(ngModel)]="listValores['peso_'+ item.codigoVariableSarlaft]"
            >
            </td>
            <td>
              <input class="align-input" type="text" pInputText autocomplete="off" appTexto numero-entero-reactive disabled maxlength="5"
                [sinComa]="true" [sinEspacio]="true" [sinCaracteres]="true" [sinPunto]="true" [sinLetras]="true"
                id="{{ 'puntaje_' + item.codigoVariableSarlaft }}"
                name="{{ 'puntaje_' + item.codigoVariableSarlaft }}"
                [(ngModel)]="listValores['puntaje_'+ item.codigoVariableSarlaft]"
              >
            </td>
            <td>
              <input class="align-input" type="text" pInputText autocomplete="off" appTexto numero-entero-reactive disabled maxlength="5"
                [sinComa]="true" [sinEspacio]="true" [sinCaracteres]="true" [sinPunto]="true" [sinLetras]="true"
                id="{{ 'resultado_' + item.codigoVariableSarlaft }}"
                name="{{ 'resultado_' + item.codigoVariableSarlaft }}"
                [(ngModel)]="listValores['resultado_'+ item.codigoVariableSarlaft]"
              >
            </td>
          </tr>
        </ng-container>
      </ng-container>
      <tr *ngIf="mostrarCuantitativas">
        <td>
          <div class="aling-total">
            <label>{{'SARLAFT.LBL_TOTAL' | translate }}</label>
          </div>
        </td>
        <td>
          <input class="align-input" type="text" pInputText autocomplete="off" appTexto numero-entero-reactive disabled
            maxlength="5" [sinComa]="true" [sinEspacio]="true" [sinCaracteres]="true" [sinPunto]="true" [sinLetras]="true"
            id="totalPesoCuantitativas" name="totalPesoCuantitativas"
            [(ngModel)]="listValores['totalPesoCuantitativas']"
          >
        </td>
        <td></td>
        <td></td>
      </tr>
    </tbody>
  </table>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <div *ngIf="!guardando">
        <a (click)="cerrarSimulador()" class="cancelar">{{'BTN_CERRAR' | translate }}</a>
        <button icon="fa fa-calculator" label="{{'SARLAFT.BTN_CALCULAR' | translate }}"
                type="submit" pButton (click)="calcularResultadoTotal()"></button>
      </div>
      <div *ngIf="guardando">
        <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
        <span>{{'LBL_GUARDANDO' | translate }}</span>
      </div>
    </div>
  </div>
<hr>
<div class="container">
  <div class="grid-container">
    <div class="resul-label-nombre">{{"SARLAFT.LBL_SCORE" | translate}}</div>
    <div class="resul-label">{{ mostrarResultado? resultadoTotal : "SARLAFT.LBL_SINRANGO" | translate }}</div>
    <ng-container *ngFor="let registro of score">
      <div *ngIf="mostrarResultado" class="resul-label-nombre">{{ registro.codigoTipoProcesoCredito === codigosTiposProcesosCreditos ? ("SARLAFT.LBL_DIGITAL" | translate ):  ("SARLAFT.LBL_RELACIONAL" | translate ) }}</div>
      <div *ngIf="mostrarResultado" class="resul-label">{{ registro? registro.nombre : '-' }}</div>
    </ng-container>
  </div>
</div>
</div>
